import { Auth } from 'aws-amplify';
import React, { useState } from 'react';
import { Link, Navigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ClipLoader } from 'react-spinners';

import './styles.scss';
import { I18n, Translate } from '@utils/i18n';

const ForgotPasswordV2: React.FC<React.PropsWithChildren> = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [redirect, setRedirect] = useState<boolean>(false);
  const emailInputRef = React.useRef<HTMLInputElement>(null);
  const [userEmail, setUserEmail] = useState('');

  const handleForgotPassword = (event: React.FormEvent) => {
    event.preventDefault();
    setLoading(true);
    if (emailInputRef.current !== null) {
      const email = emailInputRef.current.value.trim();

      setUserEmail(email);
      Auth.forgotPassword(email)
        .then(() => {
          toast.success(
            'Account confirmed successfully! Redirecting you in a few!',
            {
              autoClose: 3000,
              onClose: () => {
                setRedirect(true);
              }
            }
          );
        })
        .catch((err) => {
          toast.error(`User confirmation failed ${err.message}`);
          setLoading(false);
        });
    }
  };

  return (
    <div className="py-7 px-5">
      <div className="card-title">
        <strong>
          <Translate value="forgot_password" />
        </strong>
      </div>

      <form
        id="login-form"
        className="login-form-1"
        onSubmit={handleForgotPassword}
      >
        <div>
          <label htmlFor="lg_username" className="input__label">
            <Translate value="email" />
            &nbsp;*
          </label>
          <div className="input-group py-1">
            <input
              type="text"
              className="form-control"
              id="lg_username"
              name="email"
              placeholder="company@pulsarml.com"
              required
              ref={emailInputRef}
            />
          </div>
        </div>

        <button type="submit" className="btn mt-2 submit-button px-4">
          {loading ? (
            <ClipLoader size={20} loading color={'#fff'} />
          ) : (
            I18n.t('confirm_email')
          )}
        </button>

        <div className="text-center form-message mt-2">
          <Link to="/login">
            <Translate value="i_have_remembered" />
          </Link>
        </div>
      </form>

      {redirect && (
        <Navigate
          to={{
            pathname: '/reset-password',
            search: `?email=${userEmail}`
          }}
        />
      )}
    </div>
  );
};

export default ForgotPasswordV2;
